import { Component } from '@angular/core';
import { environment } from '@src/environments/environment';
import '@maersk-global/mds-components-core/mc-button';

@Component({
  selector: 'home',
  template: ` <div class="main">
    <section>
      <h1>{{ title }}</h1>
      <p>{{ configuration }}</p>
    </section>
  </div>`,
  styles: `
    .main {
        display: flex;
        justify-content: center;
      }
    `,
})
export class HomeComponent {
  title = 'mec-carrier-integration-ui';
  configuration = `Region: ${environment.region}, Environment: ${
    environment.production ? 'production' : 'development'
  }.`;
}
